import { NgModule } from '@angular/core';
import {
    NebulaMediaWatcherService
} from '@scientifica-cms-fe/services/media-watcher/media-watcher.service';

@NgModule({
    providers: [
        NebulaMediaWatcherService
    ]
})
export class NebulaMediaWatcherModule
{
    /**
     * Constructor
     */
    constructor(private _nebulaMediaWatcherService: NebulaMediaWatcherService)
    {
    }
}
